import React, { Component } from "react";
import PropTypes from "prop-types";
import { getFormSyncErrors, reduxForm } from "redux-form";
import { connect } from "react-redux";
import MultiSectionsModal from "../../../common/Modals/MultiSectionsModal";
import BrokerGeneral from "./formSections/BrokerGeneral";
import BrokerAdmin from "./formSections/BrokerAdmin";
import validationUtils from "../../../../utils/ValidationUtils";
import {
  applyMaxLength,
  optionalEmailValidator,
  optionalPhoneNumberValidator,
  requiredEmailValidator,
  requiredValidator,
} from "../../../../utils/validators";

class BrokerForm extends Component {
  revealFormErrors = () =>
    this.props.touch(...Object.keys(this.props.formErrors));

  render = () => {
    const { handleSubmit, translateFn, invalid } = this.props;
    return (
      <div>
        <MultiSectionsModal
          handleSubmit={handleSubmit}
          bodyClasses="BrokerModalBody"
          disableNavigation={invalid}
          revealErrors={this.revealFormErrors}
        >
          {[
            {
              sectionName: translateFn("generalInformation"),
              section: <BrokerGeneral translateFn={translateFn} />,
            },
            {
              sectionName: translateFn("adminContact"),
              section: <BrokerAdmin translateFn={translateFn} />,
            },
          ]}
        </MultiSectionsModal>
      </div>
    );
  };
}

BrokerForm.propTypes = {
  handleSubmit: PropTypes.func,
  translateFn: PropTypes.func,
  invalid: PropTypes.bool,
  touch: PropTypes.func,
  formErrors: PropTypes.object,
};

const BrokerFormValidationRules = {
  fullName: requiredValidator,
  emailAddress: requiredEmailValidator,
  adminEmailAddress: optionalEmailValidator,
  phoneNumber: optionalPhoneNumberValidator,
  adminPhoneNumber: optionalPhoneNumberValidator,
  type: requiredValidator,
  acombaNumber: applyMaxLength(),
  identificationNumber: applyMaxLength(),
};

const mapStateToProps = (state) => ({
  formErrors: getFormSyncErrors("broker")(state),
});

const BrokerReduxForm = reduxForm({
  form: "broker",
  validate: (values) =>
    validationUtils.validate(values, BrokerFormValidationRules),
})(BrokerForm);

export default connect(mapStateToProps, ...Array(2), { withRef: true })(
  BrokerReduxForm
);



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/brokers/BrokerForm.js